<template>
  <div>
    <div class="book">
      <!-- get first page -->
      <div id="pageId" class="page">
        <div class="col-md-12 maintenance-header">
          <div style="text-transform: uppercase; align-self: center;">
            {{ projectData.name }}
          </div>
        </div>
        <div class="col-md-12">
          <h4 class="maintenance-title">
            {{ $t(maintenanceModalTitle) }}
            {{ maintenanceData.code ? `#${maintenanceData.code}` : null }}
          </h4>
        </div>
        <div class="col-md-12">
          <div>
            <p>
              {{ $t("propertyMaintenance.typeOfMaintenance") }}:
              {{ getMaintenanceType }}
            </p>
          </div>
          <div>
            <p>
              {{ $t("propertyMaintenance.implementationDate") }}:
              {{ maintenanceData.maintainanceDate }}
            </p>
          </div>
        </div>
        <div class="asset-selected-table col-md-12">
          <b-table
            :items="assetItems"
            :fields="assetFields"
            :tbody-tr-class="rowClass"
          >
            <template #head()="scope">
              <div class="">{{ $t(scope.label) }}</div>
            </template>
            <template #cell(status)="row">
              {{ $t(getMaintenanceStatus(row.item.activityPlanStatus)) }}
            </template>
            <template #cell(notes)="row">
                {{ row.item.notes }}
            </template>
          </b-table>
        </div>
        <div class="col-md-12">
          <div>
            <p>
              {{ $t("propertyMaintenance.assignTo") }}:
              {{ maintenanceData.contacterName }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-print" style="position: fixed; bottom: 5px; right: 5px">
      <button
        type="button"
        class="btn btn-primary pull-right"
        @click="onPrintPage"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-print"></i>
        </span>
        {{ $t("common.print") }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import Enum from "../../../enum/enum";
import siteImgConfig from '@/lib/siteImgConfig'
import buildConfig from "../../../build/config"

export default {
  data: () => ({
    isLoading: false,
    maintenanceModalTitle: "propertyMaintenance.inProcessingMaintenanceDetail",
    maintenanceData: {
      id: 0,
      code: null,
      typeOfMaintenance: 1,
      maintenanceTypeName: null,
      maintenanceFunctionName: null,
      status: 1,
      contacterName: null,
      maintainanceDate: null,
      scheduledMaintenanceDate: null,
      maintenanceTitle: null,
      description: null
    },
    assetFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "assetCode",
        label: "common.code"
      },
      {
        key: "assetName",
        label: "property.asset.name"
      },
      {
        key: "assetSeriCode",
        label: "property.asset.seriCode"
      },
      {
        key: "assetModel",
        label: "property.asset.model"
      },
      {
        key: "notes",
        label: "common.notes",
        class: "description-content-width"
      }
    ],
    assetItems: [],
    activityPlanStatusList: [
      {
        value: Enum.AssetActivityPlanEnum.IN_PROCESSING,
        text: "propertyMaintenance.statusList.processing"
      },
      {
        value: Enum.AssetActivityPlanEnum.COMPLETE,
        text: "propertyMaintenance.assetInProcessingMaintenanceStatus.processed"
      },
      {
        value: Enum.AssetActivityPlanEnum.CANCEL,
        text:
          "propertyMaintenance.assetInProcessingMaintenanceStatus.noProcessing"
      }
    ],
    projectData: {
      name: null
    },
    siteImgConfig: siteImgConfig
  }),
  watch: {
    GET_MAINTENANCE_DETAIL_DATA: function() {
      let data = this.GET_MAINTENANCE_DETAIL_DATA;
      let assetList = data.asset_list_data;
      this.assetItems = [];
      assetList.forEach((e, index) => {
        let item = {
          id: e.id,
          nonumber: index + 1,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          assetModel: e.asset_model,
          assetSeriCode: e.seri_code,
          activityPlanStatus: e.activity_plan_status,
          notes: e.activity_plan_note
        };
        this.assetItems.push(item);
      });
      this.maintenanceData.code = data.code;
      this.maintenanceData.maintenanceTitle = data.title;
      this.maintenanceData.description = data.description;
      this.maintenanceData.maintenanceTypeName = data.maintenance_type_data.default;
      this.maintenanceData.maintenanceFunctionName = data.maintenance_function_data.default;
      this.maintenanceData.maintainanceDate = utils.formatSqlDate(data.maintainance_date,  null, "DD/MM/YYYY");
      this.maintenanceData.contacterName = data.contacter_data.full_name;
    }
  },
  computed: {
    getMaintenanceType: function() {
      let result = "";
      let maintenanceTypeName = this.maintenanceData.maintenanceTypeName;
      let maintenanceFunctionName = this.maintenanceData
        .maintenanceFunctionName;
      if (!utils.isEmptyString(maintenanceTypeName)) {
        result = maintenanceTypeName;
      }
      if (!utils.isEmptyString(maintenanceFunctionName)) {
        result += !utils.isEmptyString(result) ? ` - ${maintenanceFunctionName}` : maintenanceFunctionName;
      }
      return result;
    },
    ...mapGetters([
      "GET_MAINTENANCE_DETAIL_DATA"
    ])
  },
  methods: {
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      return "description-width";
    },
    onPrintPage: function() {
      window.print();
    },
    getMaintenanceDetail: function(maintenanceId) {
      let filter = {
        id: maintenanceId
      };
      this.isLoading = true;
      this.GET_MAINTENANCE_DETAIL(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getMaintenanceStatus: function(value) {
      let result = "";
      let index = this.activityPlanStatusList.findIndex(x => x.value === value);
      if (index !== -1) {
        result = this.activityPlanStatusList[index].text;
      }
      return result;
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===buildConfig.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo()
      link.href = siteInfo.urlIcon
      document.title = siteInfo.site_name_info
    },
    ...mapActions([
      "GET_MAINTENANCE_DETAIL"
    ])
  },
  mounted() {
    let id = this.$route.params.id;
    this.updateTabTitle()
    this.projectData.name = sessionStorage.getItem('projectName');
    this.getMaintenanceDetail(id);
  }
};
</script>
<style lang="scss" scoped>
body.print {
  overflow: initial;
}
body.print {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt;
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  width: 210mm;
  height: 297mm;
  padding: 2mm;
  margin: 10mm auto;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.subpage {
  height: 257mm;
}

@page {
  size: A4;
  margin: 0;
}
@media print {
  html {
    width: 100%;
    height: 297mm;
  }
  body.print {
    width: 100%;
    height: 297mm;
  }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
}
.theme--dark.v-sheet {
  padding: 5px;
}
//
.print-maintenance-modal {
  background: #dddddd;
  width: fit-content;
  margin: auto;
}
.maintenance-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 15mm;
}
.maintenance-header {
  height: 15mm;
  align-self: center;
  display: flex;
}
//
.asset-selected-table :deep(table thead tr th) {
  background: #dddddd;
  border: 1px solid #e4e7e8;
}
.asset-selected-table :deep(table thead tr) {
  border-top: 1px solid #e4e7e8;
}
.asset-selected-table :deep(table tbody tr td) {
  border: 1px solid #e4e7e8;
}
.asset-selected-table :deep(table) {
  border-collapse: separate;
  border-spacing: 0;
}
.asset-selected-table :deep(td:nth-child(1)) {
  width: 10%;
  white-space: nowrap;
}

.asset-selected-table :deep(.b-table .description-width .description-content-width) {
  max-width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/PrintMaintenance.vue